import React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import {
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import ArrowRightIcon from '../../../../assets/icons/Arrows-chevron/Arrow-Right.svg'
import { StudentSectionAnalysisState } from '../../../../features/types'
import ProgressBar from '../../../../components/progressBar/ProgressBar'
import { tableStyles, ui } from '../../../../utils/uiTokens'
import { capitalize } from '../../../../utils/functions'

interface Props {
    students: StudentSectionAnalysisState[]
    isFetching: boolean
}

const GroupStudentsTable: React.FC<Props> = ({
    students = [],
    isFetching = false,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={tableStyles.container}
                elevation={0}
            >
                <Table
                    sx={{ minWidth: 500 }}
                    aria-label="custom pagination table"
                >
                    <TableHead sx={tableStyles.head}>
                        <TableRow>
                            <TableCell>#</TableCell>

                            <TableCell>
                                {formatMessage({ id: 'fullName' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'group' })}
                            </TableCell>

                            <TableCell>
                                {capitalize(
                                    formatMessage({ id: 'videoLesson' }),
                                )}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'test' })}
                            </TableCell>

                            <TableCell align="right">
                                {formatMessage({ id: 'details' })}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {students.length
                            ? students.map((row, index) => (
                                  <TableRow key={row.userId} sx={tableStyles.row}>
                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {index + 1}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.firstName + ' ' + row.lastName}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.title}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          <ProgressBar value={row.watchedVideoPercentage} />
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          <ProgressBar value={row.topicTestPercentage} />
                                      </TableCell>

                                      <TableCell
                                          style={{ width: 60 }}
                                          align="right"
                                      >
                                          <Link
                                              to={`${row?.userId}/${row?.userCourseEnrollId}?courseSubjectId=${row?.courseSubjectId}`}
                                              state={{
                                                  student: row,
                                              }}
                                          >
                                              <IconButton
                                                  sx={{ background: ui.pinkSoft, borderRadius: '10px' }}
                                              >
                                                  <img
                                                      src={ArrowRightIcon}
                                                      alt="edit"
                                                  />
                                              </IconButton>
                                          </Link>
                                      </TableCell>
                                  </TableRow>
                              ))
                            : !isFetching && (
                                  <TableRow>
                                      <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                          colSpan={10}
                                      >
                                          {formatMessage({ id: 'noData' })}
                                      </TableCell>
                                  </TableRow>
                              )}
                    </TableBody>

                </Table>
            </TableContainer>
        </Box>
    )
}

export default GroupStudentsTable
